'use strict';

namespace Core {
    angular
        .module('core')
        .directive('flightAllocationSash', (tripService, $routeParams, occupancyService): ng.IDirective => {
        return {
            scope: {
                ribbon: '=?',
                isFromOverlay: '=?',
                saveAmountText: '=?',
                showFlightPreselection: '=?'
            },
            controllerAs: 'scr',
            restrict: 'E',
            link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                scope.$watch('ribbon', function(value: any) {
                    // TODO - refactor, fixes attaching several child content elements
                    element.empty();
                    const showFlightPreselection = scope.showFlightPreselection;
                    const numNonInfants = occupancyService.getNumberOfNonInfantPassengers();
                    const numFlights = TRPCONFIG.Domain2.FlightPreselectionNumFlights;
                    const baggageCost = TRPCONFIG.Domain2.FlightPreselectionBaggageCost;
                    let saveAmountText = scope.saveAmountText;

                    if (!showFlightPreselection) {
                        return;
                    }

                    async function fetchTrip(tripId) {
                        const trip = await tripService.getTrip(tripId);
                        return trip;
                    }

                    function calculateBaggageSaving(baggageCost, nonInfants) {
                        return baggageCost * nonInfants;
                    }

                    function strip(saveAmountText, numBaggageItems) {
                        const totalBaggageCost = calculateBaggageSaving(baggageCost, numBaggageItems);
                        const regex = new RegExp(/\{([0-9])\}/g);
                        return saveAmountText && saveAmountText.replace(regex, totalBaggageCost);
                    }

                     const getDetails = async () => {

                        if (!$routeParams.tripId) {
                             return;
                        }

                        const { FlightsRequest } = await fetchTrip($routeParams.tripId);

                        if (!FlightsRequest) { return; }

                        const numBaggageItems = numNonInfants * numFlights;
                        const Text = strip(saveAmountText, numBaggageItems).trim();

                        let ribbon = {
                            Text,
                            ColourClass: 'quaternary',
                            EffectClasses: ['lighten80']
                        };

                        if (ribbon) {
                            const prefix = 'sc-c-sash--';   // Sash base style class
                            const styles = [
                                'sc-c-sash',
                                `${prefix}${ribbon && ribbon.ColourClass}`
                            ]; // Sash color class style

                            ribbon.EffectClasses.forEach((effect: string) => {
                                styles.push(`${prefix}${effect}`); // Sets effect class to sash
                            });

                            const styleClass = styles.join(' ');   // Join all styles into one
                            const contentClass = 'sc-c-sash__label';

                            let ribbonElement = angular.element(`<div>`).addClass(styleClass);
                            const ribbonContent = angular.element(`<div>`).addClass(contentClass);
                            const textLengthValidator = (text: string) => text && text.slice(0, 10);
                            const textSeparator = ribbon.Text.includes('|') ? '|' : ' ';
                            const textArray: string[] = ribbon.Text.toUpperCase()
                                                                    .split(textSeparator)
                                                                    .map(textLengthValidator);
                            const textLength = textArray.length;
                            const boldStrClass = 'star-rating sc-u-bold sc-c-sash__row row-gutter-y__zero';
                            const normalStrClass = 'star-rating sc-c-sash__row row-gutter-y__zero';
                            textArray.forEach((current: string, index: number) => {
                                const isBold = ((textLength - 1) === index && textLength > 2) || index === 0;
                                const label = angular.element(`<span>${current}</span>`)
                                    .addClass(isBold ? boldStrClass : normalStrClass);
                                ribbonContent.append(label);
                            });

                            ribbonElement.append(ribbonContent);
                            element.append(ribbonElement);
                        }

                    };
                    getDetails();
                });
            }
        };

    });

}
